/**
 * Returns black or white hex color for best text contrast over a background color.
 * Uses perceived luminance formula (ITU-R BT.601).
 *
 * @param {string} hexColor - Background color hex string (e.g. '#DC1D1D')
 * @returns {string} '#000000' for light backgrounds, '#FFFFFF' for dark backgrounds
 */
export const getContrastTextColor = (hexColor) => {
  if (!hexColor) return '#FFFFFF'
  const hex = hexColor.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b
  return luminance > 186 ? '#000000' : '#FFFFFF'
}
